import { render } from "./rules-filter.vue?vue&type=template&id=00988a40&lang=pug"
import script from "./rules-filter.vue?vue&type=script&lang=js"
export * from "./rules-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__